import React from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import Toolbar from 'devextreme-react/toolbar';
import { Template } from 'devextreme-react/core/template';
import './style.scss';

export default function Dropdowns() {
  const buttonDropDownOptions = { width: 250 };
  const downloads = ['Download Trial For Visual Studio', 'Download Trial For All Platforms', 'Package Managers'];
  const profileSettings = [
    { id: 1, name: 'Profile', icon: 'user' },
    {
      id: 4, name: 'Messages', icon: 'email', badge: '5',
    },
    { id: 2, name: 'Friends', icon: 'group' },
    { id: 3, name: 'Exit', icon: 'runner' },
  ];
  const alignments = [
    { id: 1, name: 'Left', icon: 'alignleft' },
    { id: 4, name: 'Right', icon: 'alignright' },
    { id: 2, name: 'Center', icon: 'aligncenter' },
    { id: 3, name: 'Justify', icon: 'alignjustify' },
  ];
  const fontSizes = [
    { size: 10, text: '10px' },
    { size: 12, text: '12px' },
    { size: 14, text: '14px' },
    { size: 16, text: '16px' },
    { size: 18, text: '18px' },
  ];
  const lineHeights = [
    { lineHeight: 1, text: '1' },
    { lineHeight: 1.35, text: '1.35' },
    { lineHeight: 1.5, text: '1.5' },
    { lineHeight: 2, text: '2' },
  ];

  const itemTemplateRender = (item) => {
    return (<div style={{ fontSize: `${item.size}px` }}>
      {item.text}
    </div>);
  }

  const toolbarItems = [
    {
      location: 'before',
      widget: 'dxDropDownButton',
      options: {
        displayExpr: 'name',
        keyExpr: 'id',
        selectedItemKey: 3,
        width: 125,
        stylingMode: 'text',
        useSelectMode: true,
        items: alignments,
      },
    },
    {
      location: 'before',
      widget: 'dxDropDownButton',
      options: {
        stylingMode: 'text',
        displayExpr: 'text',
        keyExpr: 'size',
        useSelectMode: true,
        items: fontSizes,
        selectedItemKey: 14,
        itemTemplate: 'fontItem',
      },
    },
    {
      location: 'before',
      widget: 'dxDropDownButton',
      options: {
        stylingMode: 'text',
        icon: 'indent',
        displayExpr: 'text',
        keyExpr: 'lineHeight',
        useSelectMode: true,
        items: lineHeights,
        selectedItemKey: 1.35,
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Custom static text</div>
            <div className="form-value">
              <DropDownButton
                text="Download Trial"
                icon="save"
                dropDownOptions={buttonDropDownOptions}
                items={downloads}
              />
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Custom main button action</div>
            <div className="form-value">
              <DropDownButton
                splitButton={true}
                useSelectMode={false}
                text="Sandra Johnson"
                icon="/assets/images/avatar-2.png"
                items={profileSettings}
                displayExpr="name"
                keyExpr="id"
              />
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Usage in a toolbar</div>
            <div className="form-value">
              <Toolbar items={toolbarItems}>
                <Template name="fontItem" render={ itemTemplateRender }>
                </Template>
              </Toolbar>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
